import { CONSULTATIONS_CODES } from "./consultationsData";

export const consultationTitle = {
  [CONSULTATIONS_CODES.initial_screening]: "Consultation request",
  [CONSULTATIONS_CODES.initial_intake]: "Consultation part 1",
} as const;
